// owned by WP-SEC-UI · activity for the session clock (security §3.3, shell-ia §11.2).
// Pointer, keys, wheel, touch and a tab becoming visible are tracked by the session provider (@ncp/api-client AuthProvider), shared
// by every tab through storage. Frames (desks, custom pages) cannot reach those listeners: the page host forwards each frame's
// `activity` heartbeat here (WP-DESK-HOST), and focus moving into a frame counts as activity too.
import { markSessionActivity } from "@ncp/api-client";

/** The BroadcastChannel the ECONIC tabs share: `activity`, `signed-out` and `extended` (shell-ia §11.2). */
export const ECONIC_SESSION_CHANNEL = "econic-session";

/** A frame reported input (HostOp `activity`, throttled by page-kit to one a minute). */
export function reportFrameActivity(): void {
  markSessionActivity();
}
